module.exports = __webpack_public_path__ + "static/media/s20_cloudpink.0c49228a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/samsung-galaxy/s20/s20_cloudpink.png
// module id = 2146
// module chunks = 0